import React from "react";
import { ArrowUp } from "lucide-react";
import { NAV_LINKS, CONTACT, BRAND } from "../mock";

export default function Footer() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#090908] pt-20 pb-10 border-t border-white/[0.07]" data-testid="footer">
      <div className="container-x">
        <div className="reveal grid md:grid-cols-[1.5fr_1fr_1fr] gap-12 pb-14">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <span className="grid place-items-center w-8 h-8 rounded-[10px] bg-[#d8ff00] text-[#0e0e0d] font-bold text-[17px]">
                s
              </span>
              <span className="text-[21px] font-semibold text-white tracking-[-0.03em]">{BRAND.name}</span>
            </div>
            <p className="text-[#8b8b80] max-w-xs leading-relaxed text-sm">
              Webové studio, které navrhuje a staví rychlé moderní stránky, co prodávají. Od návrhu po spuštění —
              vše na jednom místě.
            </p>
          </div>

          <div>
            <p className="eyebrow text-[#5f5f57] mb-5">Navigace</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => go(l.href)}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-[#c9c9bf] hover:text-[#d8ff00] transition-colors text-sm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <button
                  onClick={() => go("#faq")}
                  data-testid="footer-link-faq"
                  className="text-[#c9c9bf] hover:text-[#d8ff00] transition-colors text-sm"
                >
                  Časté dotazy
                </button>
              </li>
            </ul>
          </div>

          <div>
            <p className="eyebrow text-[#5f5f57] mb-5">Kontakt</p>
            <ul className="space-y-3 text-sm text-[#c9c9bf]">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[#d8ff00] transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-[#d8ff00] transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li>{CONTACT.location}</li>
            </ul>
          </div>
        </div>

        <div className="overflow-hidden border-t border-white/[0.07] pt-10">
          <p className="script text-[#1f1f1c] text-[18vw] leading-[0.8] select-none pointer-events-none">
            {BRAND.name}
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-[#5f5f57]">© {year} {BRAND.name} — Všechna práva vyhrazena.</p>
          <button
            onClick={() => go("#top")}
            data-testid="footer-to-top"
            className="flex items-center gap-2 text-xs text-[#c9c9bf] hover:text-[#d8ff00] transition-colors"
          >
            Nahoru <ArrowUp size={15} />
          </button>
        </div>
      </div>
    </footer>
  );
}
